import { memo, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Input from '@JohnLewisPartnership/jl-design-system/elements/input/Input';
import { CloseOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/CloseOutlined';
import { SearchOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/SearchOutlined';
import styles from './FacetSearch.module.scss';
import { useFacetSearchData } from './data/useFacetSearchData';

const FacetSearch = ({
  isFilterDrawer = false,
  label = '',
  onClear = () => {},
  onSearch = () => {},
  search = '',
}) => {
  const { isLeftNavHeaderFlagOn } = useFacetSearchData();
  const hasSearchIconVisible = search.length === 0;
  const hasClearButtonVisible = search.length > 1;

  const handleSearch = useCallback((evt) => {
    const { value: newValue } = evt.target;
    onSearch(newValue);
  }, []);

  const handleClear = () => {
    onClear();
  };

  const id = `facet-search-${label}`;
  const drawerLabel = isFilterDrawer ? 'drawer-' : '';
  const placeholderText = `Search ${label}`;

  return (
    <div
      className={classnames(styles.container, {
        [styles.filterDrawer]: isFilterDrawer,
        [styles['container--lhn-header-on']]: isLeftNavHeaderFlagOn,
      })}
      data-testid={id}
    >
      <label htmlFor={id} className="visuallyHidden">
        {placeholderText}
      </label>
      <Input
        className={classnames({
          [styles['input--search-icon-showing']]: hasSearchIconVisible,
          [styles['input--clear-button-showing']]: hasClearButtonVisible,
        })}
        id={drawerLabel + id}
        name={id}
        value={search}
        placeholder={placeholderText}
        onChange={handleSearch}
        autoComplete="off"
      />
      {hasSearchIconVisible && (
        <span className={styles.searchIcon}>
          <SearchOutlined size="medium" />
        </span>
      )}
      {hasClearButtonVisible && (
        <button
          onClick={handleClear}
          className={styles.clear}
          aria-label="Reset search"
        >
          <CloseOutlined size="medium" />
        </button>
      )}
    </div>
  );
};

FacetSearch.propTypes = {
  isFilterDrawer: PropTypes.bool,
  label: PropTypes.string,
  onClear: PropTypes.func,
  onSearch: PropTypes.func,
  search: PropTypes.string,
};

export default memo(FacetSearch);
